export const FAQInfo = {
  FAQ_HEADING: "FAQ"
};